<p-card>
  <!-- Header Section -->
  <div class="flex justify-content-between align-items-center mb-4">
    <div>
      <h5 class="my-1">{{ config.title }}</h5>
      <span class="text-500">{{ config.description }}</span>
    </div>
    <p-button
      *ngIf="config.showReloadButton"
      icon="pi pi-refresh"
      label="Actualiser"
      [outlined]="true"
      size="small"
      (onClick)="onReloadClick()"
      [loading]="isLoading">
    </p-button>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="text-center my-4">
    <p-progressSpinner [style]="{width: '50px', height: '50px'}"></p-progressSpinner>
    <p class="mt-2">Chargement de l'historique...</p>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && activites.length === 0" class="text-center my-4">
    <i class="pi pi-info-circle" style="font-size: 3rem; color: var(--text-color-secondary);"></i>
    <p class="mt-2 text-color-secondary">{{ config.emptyMessage }}</p>
  </div>

  <!-- Table Content -->
  <p-table *ngIf="!isLoading && activites.length > 0"
    [value]="activites"
    tableStyleClass="tableNormale"
    autoLayout="true"
    responsiveLayout="stack"
    [breakpoint]="'768px'">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem"></th>
        <th pSortableColumn="titre">Titre<p-sortIcon field="titre"></p-sortIcon></th>
        <th pSortableColumn="description">Description<p-sortIcon field="description"></p-sortIcon></th>
        <th pSortableColumn="date">Date<p-sortIcon field="date"></p-sortIcon></th>
        <th>Employé</th>
        <th style="width: 6rem"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-activite>
      <tr>
        <td>
          <span class="activity-marker"
            [style.background-color]="getTimelineColor(activite)"
            [attr.title]="activite.titre">
            <i [class]="'pi ' + getTimelineIcon(activite)"></i>
          </span>
        </td>
        <td>
          <span class="activity-title" [style.color]="getTimelineColor(activite)">
            {{ activite.titre }}
          </span>
        </td>
        <td>
          <span class="activity-description formatted-text" *ngIf="activite.description">{{activite.description}}</span>
        </td>
        <td>
          <small class="text-500">
            <i class="pi pi-clock mr-1"></i>
            {{ formatActivityDate(activite.date || activite.dateCreation) }}
          </small>
        </td>
        <td>
          <small class="text-500" *ngIf="activite.employe">
            <i class="pi pi-user mr-1"></i>
            {{ activite.employe.prenom }} {{ activite.employe.nom }}
          </small>
        </td>
        <td>
          <p-button
            *ngIf="hasRouterLink(activite)"
            icon="pi pi-external-link"
            label="Voir détails"
            [text]="true"
            size="small"
            (onClick)="onNavigateClick(activite.routerLink!)"
            pTooltip="Naviguer vers {{ activite.routerLink }}"
            tooltipPosition="top"
            [style.color]="getTimelineColor(activite)">
          </p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-card>